import { h, Host } from "@stencil/core";
/**
 * Display a banner with text in the corner.
 */
export class YCornerBanner {
  constructor() {
    this.variant = 'info';
    this.y = 'top';
    this.x = 'left';
  }
  render() {
    return (h(Host, { ...{ [this.y]: true, [this.x]: true } }, h("slot", null)));
  }
  static get is() { return "es-corner-banner"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-corner-banner.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-corner-banner.css"]
    };
  }
  static get properties() {
    return {
      "variant": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "CornerBannerVariant",
          "resolved": "\"error\" | \"info\" | \"success\" | \"warning\"",
          "references": {
            "CornerBannerVariant": {
              "location": "local",
              "path": "/home/runner/work/Design-System/Design-System/packages/components/src/components/es-corner-banner/es-corner-banner.tsx",
              "id": "src/components/es-corner-banner/es-corner-banner.tsx::CornerBannerVariant"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Which styling variant to use."
        },
        "attribute": "variant",
        "reflect": true,
        "defaultValue": "'info'"
      },
      "y": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'top' | 'bottom'",
          "resolved": "\"bottom\" | \"top\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Y location of the banner"
        },
        "attribute": "y",
        "reflect": false,
        "defaultValue": "'top'"
      },
      "x": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "'left' | 'right'",
          "resolved": "\"left\" | \"right\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "X location of the banner."
        },
        "attribute": "x",
        "reflect": false,
        "defaultValue": "'left'"
      }
    };
  }
}
//# sourceMappingURL=es-corner-banner.js.map
